import { createReducer } from "typesafe-actions";
import {
	IVDMBunker,
	IVDMConsumption,
	IVDMDashboardStore,
	VDM_DASHBOARD_TABS,
} from "./@types";
import vdmDashboardActions, { TVDMDashbaordActions } from "./actions";
import withJobs from "redux/_core/job/reducers";
import { vdmDashboardConstants } from "./constants";

const defaultState: IVDMDashboardStore = {
	_jobs: {},
	isAlertsExpanded: false,
	smartAlerts: [],
	vdmVesselStatus: undefined,
	selectedVDMTab: VDM_DASHBOARD_TABS.BUNKER_ROBS,
	bunker: undefined,
	consumption: undefined,
	cnrForDateRange: [],
	selectedVDMDashboardDate: "",
	cnrIdForSelectedDate: "",
	dashboardContent: null,
	picContent: null,
};

const vdmDashboardReducer = createReducer<
	IVDMDashboardStore,
	TVDMDashbaordActions
>(defaultState)
	.handleAction(
		vdmDashboardActions.document.vdmVesselStatusSet,
		function vdmVesselStatusSet(state, action) {
			const { vdmVesselStatus } = action.payload;

			return {
				...state,
				vdmVesselStatus,
			};
		},
	)
	.handleAction(
		vdmDashboardActions.document.vdmTabSet,
		function vdmTabSet(state, action) {
			const { selectedVDMTab } = action.payload;

			return {
				...state,
				selectedVDMTab,
			};
		},
	)
	.handleAction(
		vdmDashboardActions.document.vdmBunkerTabDataSet,
		function vdmBunkerTabDataSet(state, action) {
			const { bunkerData } = action.payload;

			return {
				...state,
				bunker: {
					...(state.bunker ?? ({} as IVDMBunker)),
					bunkerData,
				},
			};
		},
	)
	.handleAction(
		vdmDashboardActions.document.vdmConsumptionTabDataSet,
		function vdmConsumptionTabDataSet(state, action) {
			const { consumptionData } = action.payload;
			return {
				...state,
				consumption: {
					...(state.consumption ?? ({} as Omit<IVDMConsumption, "tabType">)),
					...consumptionData,
				},
			};
		},
	)
	.handleAction(
		vdmDashboardActions.document.vdmDashboardAlertsToggle,
		function isAlertsExpanded(state, action) {
			const { isAlertsExpanded } = action.payload;

			return {
				...state,
				isAlertsExpanded,
			};
		},
	)
	.handleAction(
		vdmDashboardActions.document.vdmSmartAlertsSet,
		function vdmSmartAlertsSet(state, action) {
			const { smartAlerts } = action.payload;
			return {
				...state,
				smartAlerts,
			};
		},
	)
	// Graph 1 specific data
	.handleAction(
		vdmDashboardActions.document.vdmFuelConsumptionDistanceCoveredSet,
		function vdmFuelConsumptionDistanceCoveredSet(state, action) {
			const { fuelConsumptionDistanceCovered } = action.payload;
			return {
				...state,
				consumption: {
					...(state?.consumption ?? ({} as Omit<IVDMConsumption, "tabType">)),
					fuelConsumptionDistanceCovered,
				},
			};
		},
	)
	.handleAction(
		// Graph 2 specific data
		vdmDashboardActions.document.vdmDraftSpeedImpactOnFuelConsumptionSet,
		function vdmDraftSpeedImpactOnFuelConsumptionSet(state, action) {
			const { draftSpeedImpactOnFuelConsumption } = action.payload;
			return {
				...state,
				consumption: {
					...(state?.consumption ?? ({} as Omit<IVDMConsumption, "tabType">)),
					draftSpeedImpactOnFuelConsumption,
				},
			};
		},
	)
	.handleAction(
		vdmDashboardActions.document.vdmCNRForDateRangeSet,
		function vdmCNRForDateRangeSet(state, action) {
			const { cnrForDateRange } = action.payload;
			return {
				...state,
				cnrForDateRange,
			};
		},
	)
	.handleAction(
		vdmDashboardActions.document.vdmDashboardSelectedDateSet,
		function vdmDashboardSelectedDateSet(state, action) {
			const { date } = action.payload;
			return {
				...state,
				selectedVDMDashboardDate: date,
			};
		},
	)
	.handleAction(
		vdmDashboardActions.document.vmdDashboardAssociatedCNRIDForSelectedDate,
		function vmdDashboardAssociatedCNRIDForSelectedDate(state, action) {
			const { cnrId } = action.payload;
			return {
				...state,
				cnrIdForSelectedDate: cnrId,
			};
		},
	)
	.handleAction(
		vdmDashboardActions.document.vdmDashboardContentSet,
		function vdmDashboardContentSet(state, action) {
			const { dashboardContent } = action.payload;
			return {
				...state,
				dashboardContent,
			};
		},
	)
	.handleAction(
		vdmDashboardActions.document.vdmPICContentSet,
		function vdmPICContentSet(state, action) {
			const { picContent } = action.payload;
			return {
				...state,
				picContent,
			};
		},
	);

export default withJobs<IVDMDashboardStore>(
	vdmDashboardConstants.FEATURE,
	defaultState,
	// @ts-ignore
	vdmDashboardReducer,
);
